// Must run first: set global Buffer for create-hash (jsonwebtoken chain)
import './core/types/buffer-global';
// the above should be imported first
import { SplashScreen } from '@aibees/shared/components';
// import '@aibees/shared/styles/index.css';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FeatureFlagsProvider } from '@aibees/shared/feature-flags';
import { reportWebVitals } from '@aibees/shared/features';
import whyDidYouRender from '@welldone-software/why-did-you-render';
import React, { Fragment, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import { FEATURE_FLAGS } from './core/constants';
import { GlobalContextProvider } from './core/context/global-context';

const Wrapper = import.meta.env.STRICT ? StrictMode : Fragment;
const APP_STAGE = import.meta.env.VITE_APP_STAGE || 'dev';
const WDYR_ENABLE = import.meta.env.VITE_WDYR_ENABLE === 'true' || false;

const renderCounts: Record<string, number> = {};

function logTopRerenderedComponents(topN = 10) {
  const sorted = Object.entries(renderCounts)
    .sort(([, aCount], [, bCount]) => bCount - aCount)
    .slice(0, topN);

  console.table(
    sorted.map(([name, count]) => ({ Component: name, RenderCount: count }))
  );
}

if (APP_STAGE === 'dev' && WDYR_ENABLE) {
  whyDidYouRender(React, {
    notifier: ({ displayName, reason }) => {
      if (!renderCounts[displayName]) renderCounts[displayName] = 0;
      renderCounts[displayName]++;
      console.info(`[why-did-you-render] ${displayName}`, reason);
    },
    trackAllPureComponents: true,
    logOnDifferentValues: true, // Logs prop/state/context value diffs
    trackHooks: false, // Optional: tracks useMemo, useCallback changes
  });

  setInterval(() => {
    logTopRerenderedComponents();
  }, 10000);
}

const root = createRoot(document.getElementById('root') as HTMLElement);

// Only import and use react-scan in development environment
if (
  APP_STAGE === 'dev' &&
  typeof window !== 'undefined' &&
  typeof document !== 'undefined'
) {
  // Use setTimeout to ensure this runs after initial render
  setTimeout(async () => {
    try {
      const { scan } = await import('react-scan');
      scan({
        enabled: false,
      });
    } catch (error) {
      // Silently fail if react-scan is not available
      console.debug('react-scan not available:', error);
    }
  }, 0);
}

reportWebVitals();

root.render(
  <Wrapper>
    <BrowserRouter>
      <FeatureFlagsProvider value={{ config: FEATURE_FLAGS }}>
        <GlobalContextProvider>
          <Suspense fallback={<SplashScreen />}>
            <App />
          </Suspense>
        </GlobalContextProvider>
      </FeatureFlagsProvider>
    </BrowserRouter>
  </Wrapper>
);

window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('Failed to fetch dynamically imported module')
  ) {
    console.warn('Missing chunk detected. Reloading...');
    window.location.reload();
  }
});
